<template>
  <div class="relatorio-card-container">
    <div class="infos">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
    </div>

    <Button @handle:click="onAction" text="Gerar" color="primary">
      <DownloadOutline :size="18" />
    </Button>
  </div>
</template>

<script>
import Button from 'core/Button'
import DownloadOutline from 'icons/DownloadOutline'

export default {
  name: 'RelatorioCard',
  components: {
    Button,
    DownloadOutline,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  data() {
    return {

    }
  },
  methods: {
    onAction() {
      this.$emit('onAction')
    }
  },
}
</script>

<style lang="scss" scoped>
.relatorio-card-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .infos {
    flex: 1;

    h3 {
      margin-bottom: 0.5rem;
      font-size: 1.4rem;
      font-weight: 600;
      color: #202224;
    }

    p {
      max-width: 37.5rem;
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      color: #606264;
    }
  }
}
</style>